import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/system';
import { Box, Checkbox } from '@mui/material';
import { Typography, TextField, Grid } from '@mui/material';
import deleteIcon from '../../Images/delete_red_icon.svg';
import infoIcon from '../../Images/blue_info.svg';
import './Student.scss';
import { API, FOMRS, APP_ROUTES, ROLE } from '../../globals/constants';
import { useDispatch, useSelector } from 'react-redux';
import {
	studentID,
	showStudentDetails,
	setdeleteList,
	setfliterDeleteList,
	setcheckedList,
	setflitercheckedList,
} from '../../redux/features/student';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

const StudentList = (props) => {
	const { res, ondeleteClick } = props;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const cookies = new Cookies();
	const loginData = cookies.get('loginData');
	let userID = loginData?.id;
	let userRole = loginData?.role_code;
	let title = res?.name;
	let titlelength = title?.length;
	let slicedTitle = title?.slice(0, 20);

	let trainingCenter = res?.[`studio.studio_name`];
	let trainingCenterLength = trainingCenter?.length;
	let slicedtrainingCenter = trainingCenter?.slice(0, 18);

	let deleteTC = useSelector((state) => state.studentDetail?.deleteList);

	let selectedTC = useSelector((state) => state.studentDetail?.checkedList);

	const [checked, setChecked] = useState(false);
	const checkStudent = (e) => {
		e.stopPropagation();
	};

	const editStudent = (e) => {
		e.stopPropagation();
	};

	const deleteStudent = (e, id) => {
		e.stopPropagation();
		ondeleteClick(id);
	};

	const tcChecked = (e) => {
		setChecked(e.target.checked);
		// console.log('deleteTC', deleteTC);
		// console.log('res', res);
	};

	const selected = () => {
		dispatch(setdeleteList(res.id));
		dispatch(setcheckedList(res));
	};

	let filterdArray = (id) => {
		let filteredList = deleteTC.filter(function (item) {
			console.log('item', item);

			return item !== id;
		});
		dispatch(setfliterDeleteList(filteredList));
		console.log('filteredList', filteredList);
	};

	let filterExportObject = (id) => {
		let filteredcheckedList = selectedTC.filter(function (item) {
			// console.log('item', item.id);
			// console.log('id', id);
			return item.id !== id;
		});
		dispatch(setflitercheckedList(filteredcheckedList));
		// console.log('filteredcheckedList', filteredcheckedList);
	};

	const unselected = (TcId) => {
		// console.log('TcId', TcId.id);
		filterdArray(TcId);
		filterExportObject(TcId);
	};

	useEffect(() => {
		checked ? selected() : unselected(res.id);
	}, [checked]);

	useEffect(() => {
		console.log('reduxdeleteTC', deleteTC);
	}, [deleteTC]);

	useEffect(() => {
		console.log('::::', selectedTC);
	}, [selectedTC]);

	useEffect(() => {
		console.log('abjbdj');
		setChecked(false);
	}, [res]);

	return (
		<div>
			<Box sx={{ bgcolor: '#0C0D16', m: '1%' }} id="StudentCenter">
				<Stack
					direction="row"
					sx={{
						pt: '0.8%',
						// flexDirection: { xs: 'column', sm: 'row' }
					}}
				>
					{/* <Grid item xs={0.8} sm={0.8} md={0.8}>
						<Stack className="checkboxTC">
							<Checkbox />
						</Stack>
					</Grid> */}
					<Grid container>
						<Grid
							item
							xs={userRole === ROLE.ADMIN ? 12 : 9}
							sm={userRole === ROLE.ADMIN ? 12 : 10}
							md={userRole === ROLE.ADMIN ? 12 : 11}
							// onClick={() => {
							// 	dispatch(studentID(res?.id));
							// 	dispatch(showStudentDetails(true));
							// }}
						>
							<Stack spacing={{ sx: 1, sm: 2 }} direction="row">
								<Stack className="checkboxTC">
									<Checkbox
										checked={checked}
										onChange={(e) => {
											tcChecked(e);
										}}
										onClick={(e) => {
											checkStudent(e);
										}}
									/>
								</Stack>
								<Stack className="fs-3 mt-Row " width="25%">
									{res?.name ? titlelength > 20 ? `${slicedTitle}...` : res?.name : ""}
									{/* {res?.name} */}
								</Stack>
								<Stack
									className="SdborderRight"
									sx={{ borderRight: '1px solid #338fee', height: '30px' }}
								></Stack>
								<span className="fs-4 mt-Row " width="15%">
									{res?.created_at}
								</span>
								<Stack
									className="SdborderRight"
									sx={{ borderRight: '1px solid #338fee', height: '30px' }}
								></Stack>
								<span className="fs-4 mt-Row " width="25%">
									Training Center -
									<span className="fs-3">
										{trainingCenterLength > 18
											? `${slicedtrainingCenter}...`
											: res?.[`studio.studio_name`]}
										{/* {res?.[`studio.studio_name`]} */}
									</span>
								</span>
								{/* <Stack
								className="SdborderRight"
								sx={{ borderRight: '1px solid #338fee', height: '30px' }}
							></Stack> */}
								{/* <span className="fs-4 mt-Row ">
								Instructor -{' '}
								<span className="fs-3">{res?.[`studio.studio_name`]}</span>
							</span> */}
							</Stack>
							<Stack
								sx={{
									borderTop: '1px solid #338fee',
									// mt: '0.6%',
									width: '95%',
									marginLeft: '2.5%',
								}}
							></Stack>
							<Stack
								marginTop={{ xs: '2%', sm: '0%' }}
								sx={{
									flexDirection: { xs: 'column', sm: 'column', md: 'row' },
								}}
								justifyContent="space-evenly"
								margin="0.2%"
							>
								<Stack
									sx={{ padding: '0.7%' }}
									paddingLeft={{ xs: '5%', md: '0%' }}
									direction="row"
								>
									<Stack spacing="1%">
										<span className="fs-4">
											Average Session Length :{' '}
											<span className="fs-3">{res?.avg_session_length}hrs</span>
										</span>
									</Stack>
								</Stack>
								<Stack sx={{ borderRight: '1px solid #338fee' }}></Stack>
								<Stack
									sx={{ paddingTop: '0.5%' }}
									paddingLeft={{ xs: '5%', md: '0%' }}
									direction="row"
								>
									<span className="fs-4">
										No. of disconnect :{' '}
										<span className="fs-3">{res?.training_disconnect}</span>
									</span>
								</Stack>
								<Stack sx={{ borderRight: '1px solid #338fee' }}></Stack>
								<Stack
									sx={{ paddingTop: '0.5%' }}
									paddingLeft={{ xs: '5%', md: '0%' }}
									direction="row"
								>
									<span className="fs-4">
										No. of session attended :{' '}
										<span className="fs-3"> {res?.training_count}</span>
									</span>
								</Stack>
							</Stack>
							{/* </Stack> */}
						</Grid>
						{userRole === ROLE.ADMIN ? (
							''
						) : (
							<Grid item xs={3} sm={2} md={1}>
								<Box
									sx={{
										width: '80%',
										height: '90%',
										background: 'var(--subBoxBG)',
										borderRadius: 1.5,
										marginLeft: { xs: '5%', md: '0%' },
									}}
								>
									<Stack direction="column" spacing={1}>
										<Stack
											direction="row"
											sx={{ justifyContent: 'center', p: '5%' }}
										>
											<span className="fs-4">Action</span>
										</Stack>
										<Stack
											direction={{ xs: 'column', md: 'row' }}
											spacing={{ xs: 1, md: 2 }}
											sx={{
												justifyContent: 'center',
												paddingLeft: { xs: '36%', md: '0%' },
												cursor: 'pointer',
											}}
										>
											<Stack>
												<Stack
													spacing={1}
													sx={{ width: 20, height: 20, p: '2%' }}
												>
													<img
														src={infoIcon}
														alt=""
														onClick={(e) => {
															editStudent(e);
															navigate(APP_ROUTES.ADD_STUDENT, {
																state: {
																	type: FOMRS.VIEW,
																	id: res.id,
																},
															});
														}}
													/>
												</Stack>
											</Stack>
											<Stack>
												<Stack
													spacing={1}
													sx={{
														width: 16,
														height: 16,
														p: '2%',
														ml: '2px',
														cursor: 'pointer',
													}}
													marginTop={{ xs: 1, md: 0 }}
												>
													<img
														src={deleteIcon}
														alt=""
														onClick={(e) => {
															deleteStudent(e, res.id);
														}}
													/>
												</Stack>
											</Stack>
										</Stack>
									</Stack>
								</Box>
							</Grid>
						)}
					</Grid>
				</Stack>
			</Box>
		</div>
	);
};

export default StudentList;
